(() => {
  if (window.poeticArchiveInitialized) return;
  window.poeticArchiveInitialized = true;

  function initializeArchives() {
    const archives = [...document.querySelectorAll('[data-ps-archive]')];
    if (!archives.length) return;
    const cards = archives.flatMap((archive) => [...archive.querySelectorAll('[data-archive-card]')]);
    const controls = document.querySelector('[data-archive-controls]');
    const search = document.querySelector('[data-archive-search]');
    const book = document.querySelector('[data-archive-book]');
    const count = document.querySelector('[data-archive-count]');
    const empty = document.querySelector('[data-archive-empty]');
    const announcement = document.querySelector('[data-archive-announcement]');
    const reset = document.querySelector('[data-archive-reset]');
    if (!controls || !search || !book || !count) return;
    controls.hidden = false;
    controls.poeticArchiveController?.abort();
    const controller = new AbortController();
    controls.poeticArchiveController = controller;

    function chapterSearch(reference) {
      return reference.replace(/\b[ivxlcdm]+$/i, (roman) => {
        const values = { i: 1, v: 5, x: 10, l: 50, c: 100, d: 500, m: 1000 };
        const numbers = [...roman.toLocaleLowerCase()].map((character) => values[character]);
        return String(numbers.reduce((total, value, index) => total + (value < (numbers[index + 1] || 0) ? -value : value), 0));
      }).toLocaleLowerCase();
    }
    const searchIndex = new Map(cards.map((card) => [card, `${card.dataset.search} ${chapterSearch(card.dataset.reference || '')}`]));

    const booksInArchive = new Set(cards.map((card) => card.dataset.book));
    [...book.options].forEach((option) => {
      if (option.value) option.hidden = !booksInArchive.has(option.value);
    });

    const countLabel = (quantity) => (quantity === 1 ? count.dataset.countOne : count.dataset.countOther).replace('__COUNT__', String(quantity));
    function filterArchive(announce = true) {
      const query = search.value.trim().toLocaleLowerCase();
      const words = query.split(/\s+/).filter(Boolean);
      let visible = 0;
      cards.forEach((card) => {
        const matchesBook = !book.value || card.dataset.book === book.value;
        const matchesSearch = words.every((word) => searchIndex.get(card).includes(word));
        card.hidden = !(matchesBook && matchesSearch);
        if (!card.hidden) visible += 1;
      });
      archives.forEach((archive) => {
        if (archive.classList.contains('ps-archive--continuation')) archive.hidden = !archive.querySelector('[data-archive-card]:not([hidden])');
      });
      count.textContent = countLabel(visible);
      if (empty) empty.hidden = visible > 0;
      if (announcement && announce) announcement.textContent = countLabel(visible);
    }

    search.addEventListener('input', () => filterArchive(), { signal: controller.signal });
    book.addEventListener('change', () => filterArchive(), { signal: controller.signal });
    reset?.addEventListener('click', () => {
      search.value = '';
      book.value = '';
      filterArchive();
      search.focus();
    }, { signal: controller.signal });
    filterArchive(false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeArchives);
  else initializeArchives();
  document.addEventListener('shopify:section:load', initializeArchives);
})();
